import {MessageBox, Message} from 'element-ui';
import Language from "@/utils/language";


class MsgBox {
  constructor() {

  }

  error(text) {
    Message.error(Language.convert(text))
  }
  warning(text) {
    Message.warning(Language.convert(text))
  }
  info(text) {
    Message.info(Language.convert(text))
  }

  success(text) {
    Message.success(Language.convert(text))
  }
  /**
   * 弹出输入框
   * @param {string} message 提示消息
   * @param {string | import('element-plus').ElMessageBoxOptions} title 标题或配置项
   * @param {import('element-plus').ElMessageBoxOptions} [options] 配置项（当 title 是字符串时）
   * @returns {Promise<MessageBoxData>}
   */
  prompt(message, title, options) {
    if(options){
      options.confirmButtonText=options.confirmButtonText?Language.convert(options.confirmButtonText):options.confirmButtonText;
      options.cancelButtonText=options.cancelButtonText?Language.convert(options.cancelButtonText):options.cancelButtonText;
    }
    return MessageBox.prompt(Language.convert(message), Language.convert(title), options);
  }
  /**
   * 弹出输入框
   * @param {string} message 提示消息
   * @param {string | import('element-plus').ElMessageBoxOptions} title 标题或配置项
   * @param {import('element-plus').ElMessageBoxOptions} [options] 配置项（当 title 是字符串时）
   * @returns {Promise<MessageBoxData>}
   */

  alert(message, title, options){
    if(options){
      options.confirmButtonText=options.confirmButtonText?Language.convert(options.confirmButtonText):options.confirmButtonText;
    }
    return MessageBox.alert(Language.convert(message), Language.convert(title), options);
  }



  async showModal({title = "提示", message, confirmText = "确定", cancelText = "取消", onConfirm, onCancel}) {
    const confirmStatus = await MessageBox.confirm(Language.convert(message), Language.convert(title),
      {
        confirmButtonText: Language.convert("确定"),
        cancelButtonText: Language.convert("取消"),
        type: 'warning',
      }
    ).catch(err => err);
    // console.log(confirmStatus)
    if (confirmStatus !== "confirm") {
      onCancel && onCancel();
      return false;
    }
    onConfirm && onConfirm();
    return true;
  }

}

export default new MsgBox();



// WEBPACK FOOTER //
// ./src/utils/MsgBox.js